import { render, staticRenderFns } from "./GameTeamSuitSelector.vue?vue&type=template&id=61c980b2&"
import script from "./GameTeamSuitSelector.vue?vue&type=script&lang=js&"
export * from "./GameTeamSuitSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports